(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ImageSearch',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$('.clear-in-picker').click(function clearCriteriaInPickerClicked(e) {
			e.preventDefault();

			Adzuki.Ajax.get('/Images/imagePicker/1')
			.then(function _showImagePicker(html) {
				$('.modal-body').html(html);

				Adzuki.Form.initAjaxForm('ImageSearch');

				$('#imagesearch-keyword').val('');
			});
		});
	};

	form.success = function success(response)
	{
		if ($('.image-picker-container').length) {
			Adzuki.Ajax.get('/Images/imagePicker/0')
			.then(function _showImagePicker(html) {
				$('.modal-body').html(html);

				Adzuki.Form.initAjaxForm('ImageSearch');
			});
		} else {
			window.location.href = response['data'];

			return true;
		}

		return false;
	};

}(jQuery, window.Adzuki || {}));